// extracted by mini-css-extract-plugin
export default {"root":"root_ServicesBarChartWidget-module_jc35M"};